import apiClient from "./api";
import { PAGE_PERMISSIONS_ERROR, SET_PAGE_PERMISSIONS } from "./constants";

export const loadPagePermissions = () => async (dispatch) => {
  try {
    const { data } = await apiClient.get("/permissions");
    dispatch({ type: SET_PAGE_PERMISSIONS, payload: data });
    return data;
  } catch (error) {
    dispatch({ type: PAGE_PERMISSIONS_ERROR });
    throw error;
  }
};
